<template>
  <div class="input-group input-group-sm">
    <input
      :id="uuid"
      v-model.trim="query"
      type="text"
      class="form-control input-sm"
      placeholder="Search"
      autocomplete="off"
      @keyup.enter="goSearch">
    <div class="input-group-btn">
      <button
        type="button"
        class="btn btn-default btn-sm" 
        @click="goSearch">
        <i class="glyphicon glyphicon-search"/>
      </button>
    </div>
  </div>
</template>

<style scoped>

</style>

<script>
import algoliasearch from "algoliasearch"
import autocomplete from "autocomplete.js"
import { CurrencyMixin } from "../../mixins/CurrencyMixin"

export default {
  props: {
    uuid: {
        type: String,
        default: 'algolia-search'
    },
    appId: {
        type: String,
        default: null
    },
    apiKey: {
        type: String,
        default: null
    },
    productIndex: {
        type: String,
        default: null
    },
    listingIndex: {
        type: String,
        default: null
    }
  },

    mixins: [ CurrencyMixin ],

  data () {
    return {
      query: null,
        searchPage: true,
        jumpUrl: null,
    }
  },

  mounted () {
    const isDebug = window.jrConfig.env && (window.jrConfig.env === 'local' || window.jrConfig.env === 'beta')
    const algolia = algoliasearch(this.appId, this.apiKey)
    const listingIndex = algolia.initIndex(this.listingIndex)
    const productIndex = algolia.initIndex(this.productIndex)
    const self = this

    autocomplete("#" + this.uuid, { hint: false, debug: isDebug }, [
        {
            source: autocomplete.sources.hits(listingIndex, { hitsPerPage: 3 }),
            displayKey: 'title',
            templates: {
                header: '<div class="aa-suggestions-category">Matching Pages</div>',
                suggestion: function(hit) {
                    return '<div class="page-result"><a href="' + hit.url + '">' +
                        hit._highlightResult.title.value + '</a></div>';
                }
            }
        },
      {
        source: autocomplete.sources.hits(productIndex, {
          hitsPerPage: 6,
          attributesToRetrieve:
            "product_url,color_image_url,name,on_sale,new_style,new_colors,also_petite,petite,pricing,description",
          attributesToHighlight: "name,description",
          attributesToSnippet: ["description:30"],
          numericFilters: "qty_available>0"
        }),
        displayKey: "name",
        templates: {
          header: '<div class="aa-suggestions-category">Matching Products</div>',
          suggestion: function (hit) {
            let price = '<div class="regular-price">' + self.regularPriceLabel(hit.pricing);
            if (self.isNonUSD) {
                price += '<span class="local-currency"> (' + self.valueRange(hit.pricing.min_price, hit.pricing.max_price, self.localCurrencyCode) + '<sup>*</sup>)</span>'
            }
            price += '</div>'
            if (hit.on_sale) {
                price += '<div class="sale-price text-primary">' + self.salePriceLabel(hit.pricing)
                if (self.isNonUSD) {
                    price += '<span class="local-currency"> (' + self.valueRange(hit.pricing.min_discount_price, hit.pricing.max_discount_price, self.localCurrencyCode) + '<sup>*</sup>)</span>'
                }
                price += '</div>'
            }
            price = '<div class="text-right">' + price + '</div>'

            var size = ""
            if (hit.petite) {
              size = "Also in: regular<br>"
            } else if (hit.also_petite) {
              size = "Also in: petite<br>"
            }
            var badge = ""
            if (hit.new_style) {
                badge = '<span class="badge silver">New</span>'
            } else if (hit.new_colors) {
                badge = '<span class="badge silver">New Colors</span>'
            }

            // render the hit
            return (
              '<div class="search-result"><a href="' +
              hit.product_url +
              '">' +
              '<div class="search-result-img-container"><img alt="" src="' +
              hit.color_image_url +
              '"></div><div>' +
              '<div><strong><div class="pull-left"><span>' +
              hit._highlightResult.name.value +
              "</span>" +
              badge +
              "</div>" +
              price +
              '</strong></div>' +
              '<div class="search-result-snippet">' +
              size +
              hit._snippetResult.description.value +
              "</div></div>" +
              '<div class="clearfix"></div>' +
              "</div>"
            )
          }
        }
      }
    ]).on('autocomplete:selected', function(event, suggestion, dataset) {
        // Pages
        if (dataset === 1 && suggestion.url) {
            document.location.href = suggestion.url
            self.searchPage = false
        }

        // Products
        if (dataset === 2 && suggestion.product_url) {
            document.location.href = suggestion.product_url
            self.searchPage = false
        }
    }).on('autocomplete:updated', function() {
        if  ($(self.$el).find('.aa-suggestion').length === 1) {
            self.jumpUrl = $(self.$el).find('.aa-suggestion').find('a').attr('href');
        } else {
            self.jumpUrl = null
        }
    });
  },

  methods: {
    goSearch: function () {
        if (this.searchPage) {
            // If there is exactly one result, we go there!
            if  (this.jumpUrl) {
                document.location.href = this.jumpUrl
            } else {
                const q = this.query
                document.location.href = "/search?q=" + (q ? encodeURIComponent(q) : '')
            }
        }
        this.searchPage = true;
    }
  }
}
</script>
